import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    FEEDBACK_SUBMIT_SEND,
    FEEDBACK_SUBMIT_SUCCESS,
    FEEDBACK_SUBMIT_FAILURE,
    FEEDBACK_CLEAR
} from './supportActions';
import {
    get,
    isEqual
} from 'lodash';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case FEEDBACK_SUBMIT_SEND:
            newState = {
                ...state,
                error: null,
                sending: true
            };

            return isEqual(state, newState) ? state : newState;

        case FEEDBACK_SUBMIT_SUCCESS:
            newState = {
                ...state,
                error: null,
                sending: false,
                success: true
            };

            return isEqual(state, newState) ? state : newState;

        case FEEDBACK_SUBMIT_FAILURE:
            newState = {
                ...state,
                error: action.error,
                sending: false,
                success: false
            };

            return isEqual(state, newState) ? state : newState;

        case FEEDBACK_CLEAR:
            newState = {
                ...state,
                error: null,
                sending: false,
                success: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getSupportEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'support')
);

export const getFeedbackSubmitError = createSelector(
    getSupportEntity,
    (entity) => get(entity, 'error')
);

export const getFeedbackSubmitErrorMessage = createSelector(
    getFeedbackSubmitError,
    (error) => get(error, 'message')
);

export const getIsFeedbackSubmitSuccessful = createSelector(
    getSupportEntity,
    (entity) => get(entity, 'success')
);

export const getIsFeedbackSubmitSending = createSelector(
    getSupportEntity,
    (entity) => get(entity, 'sending')
);
